<template>
  <div>
    <component
      v-if="qrCodeComponentHandler"
      :is="qrCodeComponentHandler"
      :text="link"
      class="qr-generator__img"
    />
    <gf-custom-clipboard
      v-if="secretCode"
      class="mt-3"
      :prepended-text="$t('webhook_secret')"
      :text-to-copy="secretCode"
    />
  </div>
</template>

<script>
import sharedComponentsMessages from '@shared/shared-components/sharedComponentsMessages';
import GfCustomClipboard from '@shared/shared-components/shared/GfCustomClipboard';

export default {
  name: 'GfQrCodeGenerator',
  components: {
    GfCustomClipboard
  },
  props: {
    link: { default: null },
    loadQr: {
      default: false
    }
  },
  data() {
    return {
      secretCode: null,
      qrCodeComponentHandler: null
    };
  },
  computed: {
    isLoadQr() {
      return this.loadQr === 'true';
    }
  },
  mounted() {
    if (this.isLoadQr) this.loadQrCodeGenerator();
    this.secretCode = this.getSecretFromLink();
  },
  methods: {
    loadQrCodeGenerator() {
      // eslint-disable-next-line import/extensions
      import('vue-qr')
        .then((component) => {
          this.qrCodeComponentHandler = component.default;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSecretFromLink() {
      this.secretCode = this.link;
      const startIndex = this.secretCode.indexOf('secret=') + 7;
      const endIndex = this.secretCode.indexOf('&issuer');
      if (startIndex < 0 || endIndex < 0) {
        return null;
      }
      return this.secretCode.slice(startIndex, endIndex);
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>

<style lang="scss" scoped>
.qr-generator__img {
  margin-bottom: 16px;
}
</style>
